import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext'; // Zaimportuj kontekst
import '../styles/UserCart.css';
import ButtonRegular from './ui/ButtonRegular';
import ButtonDelete from './ui/ButtonDelete';
import getImgSrc from '../utils/getImgSrc';
import Toast from './Toast';

function UserCart() {
    // ZAKTUALIZOWANE: Pobieramy stan i funkcje z CartContext
    const { cart, fetchCart, updateItemQuantity, removeFromCart, clearCart } = useContext(CartContext);
    const { isLoggedIn } = useContext(AuthContext);
    
    const [toastMessage, setToastMessage] = useState('');
    const navigate = useNavigate();

    const showToast = (msg) => {
        setToastMessage(msg);
    }; 

    useEffect(() => {
        fetchCart();
    }, [fetchCart]);

    // Uproszczone funkcje opakowujące logikę z Contextu
    const handleCartQuantityUpdate = async (e, productId, updatedQuantity) => {
        e.stopPropagation();
        if (!isLoggedIn) {
            showToast('⚠️ Musisz być zalogowany, aby wykonać tę akcję');
            navigate('/login');
            return;
        }
        
        const result = await updateItemQuantity(productId, updatedQuantity);
        showToast(result.message);
    };

    const handleRemoveFromCart = async (productId) => {
        if (!isLoggedIn) {
            showToast('⚠️ Musisz być zalogowany, aby wykonać tę akcję');
            navigate('/login');
            return;
        }
        
        const result = await removeFromCart(productId);
        showToast(result.message);
    };

    const handleClearCart = async () => {
        if (!isLoggedIn) {
            showToast('⚠️ Musisz być zalogowany, aby wykonać tę akcję');
            navigate('/login');
            return;
        }
        
        const result = await clearCart();
        showToast(result.message);
    };

    const handleDelivery = () => {
        if (!cart || cart.items.length === 0) {
            showToast('⚠️ Twój koszyk jest pusty');
            return;
        }
        navigate('/delivery');
    };

    if (!cart) return <p>Ładowanie koszyka...</p>;

    const totalNetto = cart.items.reduce(
        (sum, item) => sum + (item.product.price / 1.23) * item.quantity,
        0
    );
    const totalBrutto = cart.items.reduce(
        (sum, item) => sum + item.product.price * item.quantity,
        0
    );

    let reservationMessage = "";
    if (cart.items.length > 0) {
        const now = new Date();
        const nextCleanMinute = Math.ceil(now.getMinutes() / 5) * 5;
        const expireTime = new Date(now);
        expireTime.setMinutes(nextCleanMinute + 30, 0, 0);

        const hours = expireTime.getHours().toString().padStart(2, '0');
        const minutes = expireTime.getMinutes().toString().padStart(2, '0');

        reservationMessage = `Rezerwacja produktów ważna do ${hours}:${minutes}`;
    }

    // (Tutaj znajdzie się reszta Twojego komponentu - return ze strukturą JSX)

	return (
		<div className="cart-table-container">
			<h2 style={{ margin: 20 }}>Twój koszyk</h2>

			{cart.items.length === 0 ? (
				<p>Koszyk jest pusty.</p>
			) : (
				<>
					{reservationMessage && (
						<p style={{ color: '#777', fontStyle: 'italic', marginTop: 10 }}>
							{reservationMessage}
						</p>
					)}

					<table className="cart-table">
						<thead>
							<tr>
								<th>#</th>
								<th>Zdjęcie</th>
								<th>Ilość</th>
								<th>Cena netto</th>
								<th>Cena brutto</th>
								<th>Wartość brutto</th>
								<th>Usuń</th>
							</tr>
						</thead>
						<tbody>
							{cart.items.map((item, index) => {
								const brutto = item.product.price;
								const netto = brutto / 1.23;
								const valueBrutto = brutto * item.quantity;

								return (
									<tr key={item.product._id}>
										<td>{index + 1}</td>
										<td>
											{item.product.images && item.product.images.length > 0 ? (
												<img
													src={getImgSrc(item.product.images[0])}
													alt={item.product.name}
													style={{
														width: '80px',
														height: '80px',
														objectFit: 'contain',
													}}
												/>
											) : (
												<div
													style={{
														width: '80px',
														height: '80px',
														background: '#eee',
														textAlign: 'center',
														lineHeight: '80px',
													}}
												>
													Brak
												</div>
											)}
										</td>
										<td>
											<input
												type="number"
												min="1"
												value={item.quantity}
												onChange={(e) => {
													const val = parseInt(e.target.value, 10);
													const qty = Number.isNaN(val) || val < 1 ? 1 : val;
													handleCartQuantityUpdate(e, item.product._id, qty);
												}}
												style={{ width: '60px' }}
											/>
										</td>
										<td>{netto.toFixed(2)} PLN</td>
										<td>{brutto.toFixed(2)} PLN</td>
										<td>{valueBrutto.toFixed(2)} PLN</td>
										<td>
											<ButtonDelete
												title={`Usuń ${item.product.name} z koszyka`}
												aria-label={`Usuń ${item.product.name}`}
												onClick={() => removeFromCart(item.product._id)}
											>
												Usuń
											</ButtonDelete>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<div className="cart-summary-table">
						<p style={{ color: '#888' }}>Suma netto: {totalNetto.toFixed(2)} PLN</p>
						<p style={{ color: '#888' }}>Suma brutto: {totalBrutto.toFixed(2)} PLN</p>
						<h3>W sumie do zapłaty: {totalBrutto.toFixed(2)} PLN</h3>
						<div className="cart-buttons">
							<ButtonDelete onClick={clearCart}>Wyczyść koszyk</ButtonDelete>
							<ButtonRegular onClick={handleDelivery}>Przejdź do danych wysyłkowych</ButtonRegular>
						</div>
					</div>
				</>
			)}

			{/* Własny tost */}
			{toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage('')} />}
		</div>
	);
}

export default UserCart;
